<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitBusinessData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.rescheduling_restructuring.detail_rescheduling_restructuring') }}</h3>
        </div>
        <div class="row">
            <div class="col-md-12 mb-4">
                <label class="input-label">{{ $tc('profile.rescheduling_restructuring.rescheduling_restructuring') }}</label><span class="text-danger"> * </span>
                <base-text-area
                    v-model="formData.rescheduling_restructuring"   
                    @input="$v.formData.rescheduling_restructuring.$touch()"          
                />
                <div v-if="$v.formData.rescheduling_restructuring.$error">
                <span v-if="!$v.formData.rescheduling_restructuring.required" class="text-danger">{{ $tc('validation.required') }}</span>
                <span v-if="!$v.formData.rescheduling_restructuring.maxLength" class="text-danger">{{ $tc('validation.rescheduling_restructuring_maxlength') }}</span>
                </div>
            </div>
              
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      formData: {
        rescheduling_restructuring: null,
      },
      isLoading: false,
    }
  },
  watch: {
  },
  validations: {
    formData: {
      rescheduling_restructuring: {
        required,
        maxLength: maxLength(255)
      },
    }
  },
  computed: {
    ...mapGetters('business', [
      'business'
    ]),
   
  }, 
  created() {
      if(this.business){
        this.formData.id=this.business.id
      }  
      if(this.business && this.business.rescheduling_restructuring){
        this.formData.rescheduling_restructuring=this.business.rescheduling_restructuring
      }
  },
  methods: {
    ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]),  
    async submitBusinessData(){
        this.$v.formData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        let  response= await this.addBusiness(this.formData)
        if (response.data) { 
            this.isLoading = false
            window.toastr['success'](this.$tc('profile.rescheduling_restructuring.saved_message'))
            return true
        }
    }
  }
}
</script>
